import {getObject, postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
import {IMissingClaimInsurance,IClaimInsuranceList} from '../../lib/Models/ClaimInsuranceModel'; 
import {IBillingResponse} from '../../lib/Models/ClaimModel'; 
 
export enum ErrorReturnMessage {
    claimInsuranceSetup = "Unable to obtain missing claim insurance details",
    claimInsuranceUpdate = "Unable to update claim insurances", 
};

export async function getMissingClaimInformation(claim_list: string[]): Promise<IResultAndError<IMissingClaimInsurance[]>>
{  
    let returnErrorMessage = "";
    const url = `api/Billing/ClaimInsurance/Setup?claim_ids=${claim_list.join(",")}`;
    const responseObject = await getObject<IMissingClaimInsurance[]>(url, (httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.claimInsuranceSetup;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}; 
export async function setClaimInsurance(payload: IClaimInsuranceList): Promise<IResultAndError<IBillingResponse>>
{ 
    return postObjectWithApiError("api/Billing/ClaimInsurance/Add", payload);
};